import { createGlobalStyle } from 'styled-components';

import TheinhardtLight from './fonts/TheinhardtLight.woff';
import TheinhardtLight2 from './fonts/TheinhardtLight.woff2';

import TheinhardtRegular from './fonts/TheinhardtRegular.woff';
import TheinhardtRegular2 from './fonts/TheinhardtRegular.woff2';

import TheinhardtMedium from './fonts/TheinhardtMedium.woff';
import TheinhardtMedium2 from './fonts/TheinhardtMedium.woff2';

import { ThemeType } from '../../theme';

export const FontStyles = createGlobalStyle<{ theme: ThemeType }>`
  @font-face {
    font-family: ${({ theme }) => theme.FONT_FACE_THEINHARDT};
    src:
      url(${TheinhardtLight}) format('woff'),
      url(${TheinhardtLight2}) format('woff2');
    font-weight: ${({ theme }) => theme.FONT_WEIGHT_LIGHT};
    font-stretch: normal;
    font-style: normal;
  }

  @font-face {
    font-family: ${({ theme }) => theme.FONT_FACE_THEINHARDT};
    src:
      url(${TheinhardtRegular}) format('woff'),
      url(${TheinhardtRegular2}) format('woff2');
    font-weight: ${({ theme }) => theme.FONT_WEIGHT_NORMAL};
    font-stretch: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: ${({ theme }) => theme.FONT_FACE_THEINHARDT};
    src:
      url(${TheinhardtMedium}) format('woff'),
      url(${TheinhardtMedium2}) format('woff2');
    font-weight: ${({ theme }) => theme.FONT_WEIGHT_MEDIUM};
    font-stretch: normal;
    font-style: normal;
  }
`;

export const GlobalStyle = createGlobalStyle<{ theme: ThemeType }>`
    *, *::before, *::after {
    box-sizing: border-box;
    outline: 0;
  }
  
  html {
    font-size: 100%;
  }
  
  body {
    -webkit-font-smoothing: antialiased;
    color: ${({ theme }) => theme.COLOR_NIGHT_RIDER};
    background: ${({ theme }) => theme.COLOR_WHITE};
    font-family: ${({ theme }) => theme.FONT_FACE_THEINHARDT};
    font-size: 1rem;
    font-smoothing: antialiased;
  }
  
  a, button {
    color: ${({ theme }) => theme.COLOR_NIGHT_RIDER};
    cursor: pointer;
    text-decoration: none;
    transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out, border-color 0.3s ease-in-out, opacity 0.3s ease-in-out;
  }
  
  input, button, textarea {
    font: inherit;
  }
  
  textarea {
    resize: none;
  }
`;
